import { Component, SimpleChanges, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { InputControlBase } from '../base/input-control-base/input-control.base';

@Component({
  selector: 'input-text-control',
  templateUrl: './input-text-control.component.html',
  styleUrls: ['./input-text-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputTextControlComponent extends InputControlBase<string> {
  
  constructor(){
    super();
  }
  protected onInit(): void {
    this.initCss();
  }  
  protected onDestroy(): void {
  }
  protected onChanges(changes: SimpleChanges): void {
  }
  protected onDoCheck(): void {
  }
  protected onAfterContentInit(): void {
  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {    
  }

  private initCss() {
    this.defaultCss += ` ${this.css}`;
  }
  
}
